module.exports = __webpack_public_path__ + "img/table1-en.0aedc608.svg";